const categories = [
	{   
		name: "Natur",
		imageURL: 'https://cdn.pixabay.com/photo/2015/06/19/21/24/the-road-815297_1280.jpg',
    },
    {
		name: 'Landschaften',
		imageURL: 'https://cdn.pixabay.com/photo/2016/10/22/17/46/scotland-1761292_1280.jpg',
    },
    {
		name: 'Gebäude',
		imageURL: 'https://cdn.pixabay.com/photo/2017/04/07/06/47/moscow-city-2210335_1280.jpg',
    },
    {
		name: 'Tiere',
		imageURL: 'https://cdn.pixabay.com/photo/2018/08/12/16/59/ara-3601194_1280.jpg',
	},
	{
		name: 'Sport',
		imageURL: 'https://cdn.pixabay.com/photo/2018/02/06/14/07/dance-3134828_1280.jpg',
	},
	{
		name: 'Menschen',
		imageURL: 'https://cdn.pixabay.com/photo/2017/08/30/12/45/girl-2696947_960_720.jpg',
	},
];
export default categories